import { render, staticRenderFns } from "./Billdetail.vue?vue&type=template&id=9bfbd4dc&scoped=true&"
import script from "./Billdetail.vue?vue&type=script&lang=js&"
export * from "./Billdetail.vue?vue&type=script&lang=js&"
import style0 from "./Billdetail.vue?vue&type=style&index=0&id=9bfbd4dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../translate-spring/user-center/person-center/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfbd4dc",
  null
  
)

export default component.exports